/* eslint-disable max-len */
// TODO: during generation numbers for task need to choose range +- 10. If number < 10,
// need to choose numbers in range [0...15], if more [10...MAX];
// MAX - startNumber + iterations * step + 10;
import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import Digit from '../animations/digit';
import Question from '../animations/question';
import Cat from '../animations/cat';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.CountingUpDown, 9]);

  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.difficulty = 1;
  this.iteration = 0;
  this.iterationConfig = this.gameConfig.sets[this.difficulty].iterations[this.iteration];

  this.iterationAnswerIndex = 0;
  this.values = [];

  this.completedStep = new Phaser.Geom.Point(0, 0);
  this.completedSequence = [];
  this.completedStart = new Phaser.Geom.Point(10, 45);

  this.taskCommonHeight = 830;
  this.taskX = 1100;
  this.taskYOffset = -20;
  this.taskDigitsCount = 3;

  this.questionMark = null;

  this.taskDigits = [];

  this.cat = null;

  this.isCatAppear = false;
  this.isClickBusy = false;

  this.isWaitForIterationComplete = false;
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CountingUpDown.Scenes.Main.prototype.constructor = EDC.Games.CountingUpDown.Scenes.Main;
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

EDC.Games.CountingUpDown.Scenes.Main.prototype.createTemplateUI = function () {
  this.createAnimations();

  this.showCountingRange();

  this.add.sprite(
    this.game.config.width / 2,
    1030,
    this.iterationConfig.order === EDC.SortTypes.ST_ASCENDING ? 'label-title-up' : 'label-title-down',
  );

  this.fillGameData();

  this.questionMark = new Question(this);
  this.questionMark.create(this.completedStart.x, this.completedStart.y);

  this.cat = new Cat(this);
  this.cat.create(
    (this.game.config.height - this.taskCommonHeight) / 2 + this.taskYOffset,
    (this.game.config.height - this.taskCommonHeight) / 2 + this.taskYOffset + this.taskCommonHeight,
  );
  this.cat.setAppearanceTarget(
    this.taskX - this.cat.getSize().width - this.cat.getSize().width / 3,
    (this.game.config.height - this.taskCommonHeight) / 2 + this.taskYOffset + this.taskCommonHeight / 2,
  );

  this.showStartValues();
};

EDC.Games.CountingUpDown.Scenes.Main.prototype.loadIteration = function () {
  this.createTask();
};

EDC.Games.CountingUpDown.Scenes.Main.prototype.createAnimations = function () {
  const animsCfg = {
    catAppear: {
      key: 'catAppear',
      frames: this.anims.generateFrameNumbers('cat', { start: 0, end: 7, first: 0 }),
      frameRate: 7,
      repeat: -1,
    },
    catExplode: {
      key: 'catExplode',
      frames: this.anims.generateFrameNumbers('explosion', { start: 0, end: 7, first: 0 }),
      frameRate: 7,
    },
    stars: {
      key: 'stars',
      frames: this.anims.generateFrameNumbers('stars', { start: 0, end: 3, first: 0 }),
      frameRate: 5,
    },
    cometFly: {
      key: 'cometFly',
      frames: this.anims.generateFrameNumbers('comet', { start: 0, end: 2, first: 0 }),
      frameRate: 9,
      repeat: -1,
    },
  };

  Object.entries(animsCfg).forEach(([key]) => {
    const cfg = animsCfg[key];
    this.anims.create(cfg);
  });
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.showCountingRange = function () {
  const countingRangeContainer = this.add.container(0, 0);
  const commonStyle = {
    fontFamily: 'Arial',
    fontSize: 55,
    fontStyle: 'italic',
    color: '#ffffff',
  };
  const digitStyle = {
    fontFamily: 'Arial',
    fontSize: 70,
    fontStyle: 'italic',
    color: '#ffff00',
  };
  const textCommon = this.add
    .text(
      0,
      70,
      `Counting ${this.iterationConfig.order === EDC.SortTypes.ST_ASCENDING ? 'UP' : 'DOWN'} from `,
      commonStyle,
    )
    .setOrigin(0, 1);
  const textFrom = this.add
    .text(textCommon.x + textCommon.displayWidth, 75, this.iterationConfig.countStart, digitStyle)
    .setOrigin(0, 1);
  const textBy = this.add.text(textFrom.x + textFrom.displayWidth, 70, ' by ', commonStyle).setOrigin(0, 1);
  const textByDigit = this.add
    .text(textBy.x + textBy.displayWidth, 75, this.iterationConfig.countBy, digitStyle)
    .setOrigin(0, 1);

  countingRangeContainer.add([textCommon, textFrom, textBy, textByDigit]);

  const bounds = countingRangeContainer.getBounds();

  countingRangeContainer.x = (this.game.config.width - bounds.width) / 2;
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.showStartValues = function () {
  const valuesCount = this.iterationConfig.countBy > 1 ? 2 : 1;
  for (let i = 0; i < valuesCount; i++) {
    const value = this.values[this.iterationAnswerIndex];
    this.completeValue(value, true);
    this.iterationAnswerIndex = this.iterationAnswerIndex + 1;
  }
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.checkIsDead = function () {
  for (let i = 0; i < this.taskDigits.length; i++) {
    if (!this.taskDigits[i].isDead) {
      return false;
    }
  }
  return true;
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.allowInteract = function () {
  this.isCatAppear = true;
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.taskClicked = function (clickedValue, digitObj) {
  if (this.cat.isBusy) return;
  if (clickedValue === this.values[this.iterationAnswerIndex]) {
    this.isClickBusy = false;
    this.isWaitForIterationComplete = true;
    digitObj.setCorrect(() => {
      this.cat.flyTo(digitObj.getPosition().x, digitObj.getPosition().y,
        digitObj.destroyAnim.bind(digitObj, true));
      for (let i = 0; i < this.taskDigits.length; i++) {
        if (this.taskDigits[i] !== digitObj) {
          this.taskDigits[i].destroyAnim(false);
        }
      }
      this.completeValue(clickedValue);
      this.iterationAnswerIndex = this.iterationAnswerIndex + 1;
      this.playCorrect();
    });
  } else {
    this.cat.explode();
    this.isCatAppear = false;
    this.playWrong();
    digitObj.setWrong();
    this.isClickBusy = false;
  }
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.createTaskIfNeeded = function () {
  if (this.checkIsDead()) {
    if (this.iterationAnswerIndex < this.iterationConfig.countSteps) {
      this.loadIteration();
    } else {
      this.showSummary();
    }
  }
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.createTask = function () {
  this.iterationConfig = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  this.isWaitForIterationComplete = false;
  for (let i = 0; i < this.taskDigits.length; i++) {
    this.taskDigits[i].destroy();
  }
  this.taskDigits = [];

  const source = [];
  for (let si = 0; si < 100; si++) {
    source.push(si);
  }

  const rndValuesData = [];

  const slotHeight = this.taskCommonHeight / this.taskDigitsCount;
  const slotStartY = (this.game.config.height - this.taskCommonHeight) / 2 + this.taskYOffset;

  const currentItemIdx = source.indexOf(this.values[this.iterationAnswerIndex]);
  if (currentItemIdx !== -1) {
    source.splice(currentItemIdx, 1);
  }

  for (let ti = 0; ti < this.taskDigitsCount; ti++) {
    const rndValue = this.getRandomValueFromArray(source);
    rndValuesData.push(rndValue);
  }

  const rndIndex = Math.floor(Math.random() * rndValuesData.length);
  rndValuesData[rndIndex] = this.values[this.iterationAnswerIndex];

  for (let i = 0; i < rndValuesData.length; i++) {
    const digit = new Digit(this, this.createTaskIfNeeded.bind(this));
    digit.create(
      rndValuesData[i],
      this.taskX,
      slotStartY + slotHeight * i + slotHeight / 2,
      0,
      1,
      true,
    );
    digit.appearBig();
    digit.makeInteractive();
    this.taskDigits.push(digit);
  }

  this.cat.appear();
  this.isWaitForIterationComplete = false;
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.completeValue = function (value, isImmediate = false) {
  const digit = new Digit(this);
  digit.create(value, 0, 0, 1, 0, false);
  let { x } = this.completedStart;
  let { y } = this.completedStart;
  x += digit.getSize().width / 2;
  if (this.completedSequence.length) {
    const lastDigit = this.completedSequence[this.completedSequence.length - 1];
    y = lastDigit.getPosition().y + lastDigit.getSize().height / 2 + digit.getSize().height / 2 + this.completedStep.y;
  }
  this.completedSequence.push(digit);
  digit.place(x, y);
  digit.setAlpha(1);
  this.questionMark.moveTo(x, y + digit.getSize().height / 2, isImmediate);
  digit.appearCompletedSeq(isImmediate);
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.getRandomValueFromArray = function (targetArray) {
  const rndIdx = Math.floor(Math.random() * targetArray.length);
  const res = targetArray.splice(rndIdx, 1);
  return res[0];
};
/**
 *
 */
EDC.Games.CountingUpDown.Scenes.Main.prototype.fillGameData = function () {
  let value = this.iterationConfig.countStart;
  this.values.push(value);
  for (let i = 0; i < this.iterationConfig.countSteps - 1; i++) {
    value = this.iterationConfig.order === EDC.SortTypes.ST_ASCENDING ? value + this.iterationConfig.countBy : value - this.iterationConfig.countBy;
    if (value < 0) {
      value = 0;
    }
    this.values.push(value);
  }
};

export default EDC.Games.CountingUpDown.Scenes.Main;
